import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfigService } from 'src/app/core/service/config.service';
import { AuctionsService } from 'src/app/features/rooms/core/service/auctions.service';

@Component({
  selector: 'app-delivered-and-collected',
  templateUrl: './delivered-and-collected.component.html'
})
export class DeliveredAndCollectedComponent implements OnInit {
  loading =false;
  LoadingUploadMedia: boolean = false;
  isSubmitted: boolean = false
  files: any[] = []
  deliveredForm:FormGroup;
  formSubmitAttempt = false;
  constructor(
    private fb: FormBuilder, 
    public _config: ConfigService,
    private apiService: AuctionsService,
    public dialogRef: MatDialogRef<DeliveredAndCollectedComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any 

    
    ) { 
    this.deliveredForm = this.fb.group({note: new FormControl()})
  }

  ngOnInit() {
  }
  onSubmit(){
    this.formSubmitAttempt = true;

    if (this.deliveredForm.invalid ) {
      return;
    }
    this.loading = true;

    const modal = {
      attached_file: this.files,
      note : this.deliveredForm.value['note'] ?  this.deliveredForm.value['note'] : ''
    };

    this.apiService.delivered(modal,this.data.id).subscribe({
      next: (data: any) => {
        this.loading = false;
        this._config.toastrService.success(this._config.translate.instant('Auctions.Delivered and collected'));
        this.dialogRef.close('success');
      }, error: (error: any) => {
        // error.errors.forEach((err: any) => {
        //   this._config.toastrService.error(err.massage);
        // });
        this._config.showErrors(error);

        this.loading = false;
      }
    })


  }
}
